import { render } from "./quarter-table.vue?vue&type=template&id=0a447f9c&scoped=true"
import script from "./quarter-table.vue?vue&type=script&lang=ts"
export * from "./quarter-table.vue?vue&type=script&lang=ts"

import "./quarter-table.vue?vue&type=style&index=0&id=0a447f9c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0a447f9c"

export default script